// Minimal replacement for `vuex-router-sync` (KAT-943 Phase 2b): that package has no stable
// Vue 3 release (its `vue` module line is stuck at a years-old `6.0.0-rc.1`). This module keeps
// the exact same shape other code depends on — `store.modules.book`'s `currentPageNumber` getter
// reads `rootState.route.params.pageNumber` — while being synced from `main.js` via a plain
// `watch(() => router.currentRoute.value, ...)` instead of vuex-router-sync's internal
// `router.afterEach` hook.
const state = {
  path: '',
  fullPath: '',
  name: null,
  params: {},
  query: {},
  meta: {}
}

const mutations = {
  UPDATE_ROUTE (state, route) {
    state.path = route.path
    state.fullPath = route.fullPath
    state.name = route.name
    state.params = route.params
    state.query = route.query
    state.meta = route.meta
  }
}

export default {
  state,
  mutations
}
